import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Button from '../../../../components/Button';
import { SupportText } from '../../../../components/Support';
import Text from '../../../../components/Text';
import { sendPasswordCode } from '../../../../services/user';
import { ModalContainer } from '../../styles';
import Spacing from '../../../../components/Spacing';

const Modal = ({ onConfirm }) => {
  const credentials = useSelector(state => state.main.credentials);
  const history = useHistory();

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      if (!credentials) {
        history.replace('/login');
      }
    })()
  }, [history, credentials])

  const handleOnClick = useCallback(async () => {
    if (loading) {
      return
    };
    try {
      setLoading(true);
      await sendPasswordCode({ [credentials.field]: credentials.value });
      setLoading(false);
      onConfirm();
    } catch (err) {
      history.replace('/login');
    }
  }, [credentials, history, loading, onConfirm]);
 
  return credentials && (
    <ModalContainer>
      <Text variant="regular">
        Deseja enviar no e-mail abaixo o seu código de 4 dígitos para mudar a senha?
      </Text>

      <Spacing size={24} />
      <input type="text" disabled value={credentials.publicValue} />
      <Button text="Sim, enviar código" onClick={handleOnClick} loading={loading} variant="buttonPrimary" />
      <SupportText />
    </ModalContainer >
  )
}

export default Modal;
